import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import BrandGlyph from "./BrandGlyph";

const groups = [
  [
    "Services",
    [
      ["Website Design", "/services/websites"],
      ["SEO", "/services/seo"],
      ["AI Search", "/services/ai-search"],
      ["Automation", "/services/automation"],
      ["Website Care", "/services/support"],
    ],
  ],
  [
    "Company",
    [
      ["Pricing & Packages", "/services/website-packages"],
      ["Our Work", "/work/khim-thai-restaurant"],
      ["About", "/about"],
      ["Contact", "/contact"],
      ["Website Concepts", "/concepts"],
    ],
  ],
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#090806] text-white">
      <div className="mx-auto grid max-w-[1500px] gap-10 px-5 py-11 sm:grid-cols-[1.2fr_1fr] sm:px-9 sm:py-14 lg:px-14">
        <div>
          <Link
            to="/"
            aria-label="Thrivehaus Digital home"
            className="inline-flex items-center gap-2.5"
          >
            <span className="font-display text-xl font-semibold tracking-[-.04em] text-[#f5efe6]">
              THRIVEHAUS
            </span>
            <span className="font-mono text-[11px] font-semibold tracking-[.32em] text-[#d0a26b]">
              DIGITAL
            </span>
            <BrandGlyph className="ml-0.5 h-5 w-7" />
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-[1.7] text-white/80">
            Web design, search visibility, automation and website care. Based in
            Adelaide, working with businesses everywhere.
          </p>
          <a
            href="tel:+61452363972"
            className="mt-4 inline-block font-mono text-[12px] tracking-[.12em] text-[#d0a26b] hover:text-[#e2b883]"
          >
            Call 0452 363 972
          </a>
          <a
            href="mailto:hello@thrivehausdigital.com.au"
            className="mt-2 block font-mono text-[12px] tracking-[.12em] text-[#d0a26b] hover:text-[#e2b883]"
          >
            hello@thrivehausdigital.com.au
          </a>
        </div>
        <nav aria-label="Footer" className="grid grid-cols-2 gap-6">
          {groups.map(([heading, links]) => (
            <div key={heading}>
              <p className="font-mono text-[12px] font-semibold uppercase tracking-[.18em] text-[#d0a26b]">
                {heading}
              </p>
              <div className="mt-4 flex flex-col gap-3">
                {links.map(([label, to]) => (
                  <Link
                    key={to}
                    to={to}
                    className="text-sm leading-snug text-white/85 transition-colors hover:text-white"
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </nav>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1500px] flex-wrap items-center justify-between gap-4 px-5 py-5 sm:px-9 lg:px-14">
          <p className="font-mono text-[11px] uppercase tracking-[.12em] text-white/80">
            © {new Date().getFullYear()} Thrivehaus Digital · Adelaide
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/privacy"
              className="text-xs text-white/80 hover:text-white"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-xs text-white/80 hover:text-white"
            >
              Terms
            </Link>
            <a
              href="https://wa.me/61452363972?text=Hi%20Thrivehaus%2C%20I%27d%20like%20to%20chat%20about%20a%20website."
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chat with Thrivehaus Digital on WhatsApp"
              className="text-[#d0a26b] hover:text-[#e2b883]"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                className="h-4 w-4"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/thrivehausdigital"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Thrivehaus Digital on Instagram"
              className="text-[#d0a26b] hover:text-[#e2b883]"
            >
              <Instagram className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
